<template>
  <div>
    <Head :title="__('Dashboard')" />

    <!-- Select input for organization -->
    <select-input v-if="user_access.dashboard_asset_management.update" v-model="valueOrganizationId" @change="onOrganizationChange" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Customer')" :required="true">
      <!-- Option for All Data -->
      <option :value="''">{{ __('All Data') }}</option>
      <!-- Options for organizations -->
      <option v-for="s in organization" :key="s.id" :value="s.id">{{ s.name }}</option>
    </select-input>

    <!-- Badge items section -->
    <div class="badge__items flex flex-col lg:flex-row gap-5">
      <div class="badge__item h-32 w-full lg:w-1/3 cursor-pointer">
        <div class="l__items bg-white rounded-lg shadow-lg flex justify-between w-full">
          <div class="badge__info">
            <span class="title">{{ __('Total Stock Asset') }}</span>
            <span class="number">{{ total_stock_asset }}</span>
          </div>
        </div>
      </div>
      <div class="badge__item h-32 w-full lg:w-1/3 cursor-pointer">
        <div class="l__items bg-white rounded-lg shadow-lg flex justify-between w-full">
          <div class="badge__info">
            <span class="title">{{ __('Total Outgoing Asset') }}</span>
            <span class="number">{{ total_outgoing }}</span>
          </div>
        </div>
      </div>
      <div class="badge__item h-32 w-full lg:w-1/3 cursor-pointer">
        <div class="l__items bg-white rounded-lg shadow-lg flex justify-between w-full">
          <div class="badge__info">
            <span class="title">{{ __('Total PIC') }}</span>
            <span class="number">{{ total_pic }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Recently Outgoing Asset table -->
    <div class="response__details flex flex-col lg:flex-row mt-8 gap-5">
      <div class="flex gap-5 flex-col lg:flex-row lg:w-full w-full">
        <div class="w-full">
          <div class="r__wrapper flex flex-col p-5 bg-white rounded-lg shadow-lg rd">
            <h2 class="th__ttl font-bold text-lg pt-3 mb-6">{{ __('Recently Outgoing Asset') }}</h2>
            <div class="bg-white rounded-md shadow overflow-x-auto">
              <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                  <th class="px-6 pt-6 pb-4">{{ __('Transaction Code') }}</th>
                  <th class="px-6 pt-6 pb-4">{{ __('Customer') }}</th>
                  <th class="px-6 pt-6 pb-4">{{ __('Users') }}</th>
                  <th class="px-6 pt-6 pb-4">{{ __('Date') }}</th>
                </tr>
                <tr v-if="data_exit_goods && data_exit_goods.length > 0" v-for="item in data_exit_goods" :key="item.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                  <td class="border-t px-6 py-4 items-center focus:text-indigo-500">{{ item.transaction_code }}</td>
                  <td class="border-t px-6 py-4 items-center focus:text-indigo-500">{{ item.organization_id }}</td>
                  <td class="border-t px-6 py-4 items-center focus:text-indigo-500">{{ item.customer_id }}</td>
                  <td class="border-t px-6 py-4 flex items-center focus:text-indigo-500">{{ moment(item.created_at).fromNow() }}</td>
                </tr>
                <tr v-else>
                  <td colspan="4" class="border-t px-6 py-4 text-center">No data found</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading Process -->
    <div v-if="loading" class="processing-overlay">
      <div class="background"></div>
      <div class="loader">
        <!-- Loader SVG -->
      </div>
    </div>
  </div>
</template>

  <script>
import { Head } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import moment from 'moment'
import axios from 'axios'
import SelectInput from '@/Shared/SelectInput'

export default {
  metaInfo: { title: 'Dashboard' },
  components: {
    Head,
    SelectInput,
  },
  layout: Layout,
  props: {
    auth: Object,
    total_stock_asset: Number,
    total_outgoing: Number,
    total_pic: Number,
    data_exit_goods: Object,
    organization: Array,
  },
  data() {
    return {
      errors: [],
      user_role: this.$page.props.auth.user.role,
      user_access: this.$page.props.auth.user.access,
      loading: false,
      valueOrganizationId: '', // Initialized with an empty string for All Data
    }
  },

  created() {
    this.moment = moment

    let organizationIdFromUrl = ''
    if (this.$route && this.$route.query) {
      organizationIdFromUrl = this.$route.query.organization_id || ''
    } else {
      // Fallback: parse the URL manually
      const params = new URLSearchParams(window.location.search)
      organizationIdFromUrl = params.get('organization_id') || ''
    }

    this.valueOrganizationId = organizationIdFromUrl
  },

  methods: {
    goToLink(link) {
      window.location.href = link
    },

    filterOrganization(e) {
      // Fetch organizations from the server based on user input
      axios.get(this.route('filter.organizations', { search: e.target.value })).then((res) => {
        this.organization.splice(0, this.organization.length, ...res.data)
      })
    },

    onOrganizationChange(e) {
      const selectedValue = e.target.value || '' // Use empty string for "All Data"

      this.valueOrganizationId = selectedValue

      this.loading = true

      this.$inertia.get(
        this.route('asset_management.dashboard'),
        { organization_id: this.valueOrganizationId },
        {
          preserveScroll: true,
          onSuccess: () => {
            this.loading = false
          },
          onError: () => {
            this.loading = false
          },
        },
      )
    },
  },

  watch: {
    valueOrganizationId(newVal) {
      // Ensure the select input reflects the correct value
      if (newVal === '') {
        this.valueOrganizationId = ''
      }
    },
  },
}
</script>
